module.exports = "<!-- Display title -->\r\n<div class=\"jumbotron\">\r\n  <div class=\"container\">\r\n    <h1 class=\"display-3\">Grim3212</h1>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"container\">\r\n    <div class=\"text-center\">\r\n        <a routerLink=\"/grim-pack\"><img class=\"img-fluid rounded shadow\" src=\"https://i.imgur.com/qX7K56R.png\" /></a>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/home/home.component.html
// module id = ../../../../../src/app/containers/home/home.component.html
// module chunks = main